import React, { useState, useEffect } from "react";
import './registration.css';
import manImg from '../../../public/img/man.png'
import InputMask from 'react-input-mask';
import { useParams } from "react-router-dom";

const ClientRegistrationForm = () => {
    const [showCodeInput, setShowCodeInput] = useState(false);
    const [phone, setPhone] = useState('');
    const [code, setCode] = useState('');
    const [error, setError] = useState(null);
    const { link } = useParams();

    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    useEffect(() => {
        if (link) {
          localStorage.setItem("meetmindInviteLink", link);
        }
      }, [link]);

    const handleSubmitPhone = async (e) => {
        e.preventDefault();
        setError(null);

        try {
            const response = await fetch('https://meetmind.ru/v1/client/auth/send-reg-sms', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ phone }),
            });

            if (response.ok) {
                setShowCodeInput(true);
            } else {
                const errorData = await response.json();
                setError(errorData.message || 'Ошибка при отправке кода');
            }
        } catch (error) {
            setError('Ошибка сети, попробуйте еще раз.');
        }

        if (error != null) {
            alert(error);
        }
    };

    const handleSubmitCode = async (e) => {
        e.preventDefault();
        setError(null);

        try {
            const response = await fetch('https://meetmind.ru/v1/client/auth/check-reg-sms', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ phone, code, link, 'time_zone': timeZone }),
            });

            if (response.ok) {
                setShowCodeInput(false);
            } else {
                const errorData = await response.json();
                setError(errorData.message || 'Ошибка при проверке кода');
            }
        } catch (error) {
            setError('Ошибка сети, попробуйте еще раз.');
        } finally {
            window.location.href = "/client-questionary";
        }

        if (error != null) {
            alert(error);
        }
    };

    const handlePhoneChange = (e) => {
        let phone = e.target.value.replace(/\D/g, '');

        setPhone(phone);
    };

    const handleCodeChange = (e) => {
        setCode(e.target.value);
    };
    return (
        <div className="registration">
            <h1 className="registration__title">Вы были приглашены на “MeetMind”!</h1>
            <div className="registration__row">
                {!showCodeInput ? (
                    <form className="registration__form" onSubmit={handleSubmitPhone}>
                        <h4 className="registration__subtitle">
                            Удобная и быстрая регистрация.
                        </h4>
                        <p className="registration__paragraph">
                            Введите свой номер телефона
                        </p>
                        <div className="registration__field">
                            <InputMask
                                mask="+7 (999) 999-99-99"
                                placeholder="+7 (___) ___-__-__"
                                className="registration__input input"
                                type="tel"
                                id="phone"
                                required
                                value={phone}
                                onChange={handlePhoneChange}
                            />
                        </div>
                        <div className="registration__actions">
                            <button type="submit" className="registration__button button">Получить код</button>
                        </div>
                        <p className="registration__paragraph registration__agreements">
                            Вводя свой номер, вы принимаете условия <a href="#!" target="blank" className="registration__link link">пользовательского соглашения</a>, даёте <a href="#!" target="blank" className="registration__link link">согласие на обработку персональных данных</a> и на получение СМС-паролей, а также иных информационных и сервисных сообщений на указанный номер телефона.
                        </p>
                    </form>
                ) : (
                    <form className="registration__form" onSubmit={handleSubmitCode}>
                        <h4 className="registration__subtitle">
                            Подтверждение телефона
                        </h4>
                        <p className="registration__paragraph">
                            Введите код из СМС-сообщения, отправленного на номер {phone}
                        </p>
                        <div className="registration__field">
                            <input
                                className="registration__input input"
                                type="text"
                                id="code"
                                required
                                value={code}
                                onChange={handleCodeChange}
                            />
                        </div>
                        <div className="registration__actions">
                            <button type="submit" className="registration__button button">Продолжить</button>
                        </div>
                    </form>
                )}
                <div className="registration__image">
                    <img src={manImg} alt="Logo" />
                </div>
            </div>
        </div>
    );
};

export default ClientRegistrationForm;